import React, { useState, useEffect, useContext } from "react";
import { reduxForm, Field } from "redux-form"
import queryString from "query-string";
import { withRouter, Link } from "react-router-dom";
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Alert } from 'reactstrap';

import { ThemeContext } from "corp-site/employer/context/ThemeContext";

import { UpwardLoadingButton, UpwardReduxInput } from "ui";
import FormValidators from "ui/FormValidators";

import { employerResetPasswordConfirm } from "../../services/EmployerServices";

const defaultUserParams = { "id": null, "token": null };
const defaultErrorMessage = { "success": false, "message": "" };

const EmployerResetPassword = withRouter((props) => {
    const qs = queryString.parse(props.location.search);
    const context = useContext(ThemeContext);
    const [idTokenParams, setIdToken] = useState(defaultUserParams);
    const [isLoading, setIsLoading] = useState(false);
    const [passwordError, setPasswordError] = useState(defaultErrorMessage);

    useEffect(() => {
        if (qs && qs.id && qs.token) {
            setIdToken({ "id": qs.id, "token": qs.token });
        }
        return () => {
            setIdToken(Object.assign({}, defaultUserParams));
        }
    }, []);

    const onCloseModal = () => {
        props.history.push(props.location.pathName);
    }


    const handleFormSubmit = (data) => {
        setIsLoading(true);
        const formData = Object.assign({}, data, idTokenParams);
        employerResetPasswordConfirm(formData).subscribe(
            (loginResponse) => {
                if (loginResponse.response === "success") {
                    setPasswordError((prevMessage) => {
                        return Object.assign({}, prevMessage, { "success": true, "message": loginResponse.message })
                    });
                } else {
                    setPasswordError((prevMessage) => {
                        return Object.assign({}, prevMessage, { "success": false, "message": loginResponse.message })
                    });
                }
                setIsLoading(false);
            }
        )
    }

    return (
        <Modal isOpen={true} className={(props.className ? props.className : "") + " rounded_modal signin-modal"} toggle={onCloseModal} keyboard={true} >
            <button type="button" onClick={onCloseModal} className="close modalClose" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <ModalHeader>Create new password</ModalHeader>
            <ModalBody>
                <Row>
                    <Col xs={{ "size": 10, "offset": 1 }}>
                        <form onSubmit={props.handleSubmit(handleFormSubmit)}>
                            {passwordError.message &&
                                passwordError.message.length > 0 && (
                                    <Alert color={passwordError.success ? "success" : "danger"} className="my-3">
                                        <div className="alert-message">
                                            {passwordError.message}
                                        </div>
                                    </Alert>
                                )
                            }
                            <div className="form-group">
                                <Field
                                    type="password"
                                    bsSize="lg"
                                    placeholder="New Password"
                                    name="password"
                                    component={UpwardReduxInput}
                                    validate={[FormValidators.required]} />
                            </div>
                            <Row>
                                <Col xs={{ "size": 6, "offset": 3 }} className="mt-4">
                                    <UpwardLoadingButton block type="submit" color="primary" size="lg" isLoading={isLoading}
                                        className={"btn-rounded " + (context === "green" ? "btn-light-" + context : "btn-dark-" + context)}><b>Submit</b></UpwardLoadingButton>
                                </Col>
                            </Row>
                        </form>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter className="clearfix">
                <div className="float-left">
                    <Link to="/employers?signin=y">Sign in</Link>
                </div>
                <div className="float-right">
                </div>
            </ModalFooter>
        </Modal>
    )

});


export default reduxForm({
    form: "employerCreatePassword"
})(EmployerResetPassword);